import React from 'react';
import { shortenAddress } from '../../utils/format';
import { Spinner } from '../common/Loader';
import './UserHeader.css';

// Generate deterministic gradient colors from an address hash
function addressToGradient(address) {
  if (!address) return { c1: '#00E5A0', c2: '#059669' };
  const hash = address.toLowerCase().replace('0x', '');
  const h1 = parseInt(hash.slice(0, 6), 16) % 360;
  const h2 = (h1 + 60) % 360;
  return {
    c1: `hsl(${h1}, 70%, 55%)`,
    c2: `hsl(${h2}, 70%, 45%)`,
  };
}

function initialsFromAddress(address) {
  if (!address) return 'XT';
  return address.slice(2, 4).toUpperCase();
}

export default function UserHeader({
  userId,
  user,
  account,
  isActive,
  onRefresh,
  refreshing,
}) {
  const grad = addressToGradient(account);
  const initials = initialsFromAddress(account);

  return (
    <div className="user-header">
      <div className="uh-logo">
        <img src="/logos/xterra-icon.png" alt="X-Terra" />
      </div>

      <div className="uh-avatar-wrap">
        <div
          className="uh-avatar"
          style={{ background: `linear-gradient(135deg, ${grad.c1}, ${grad.c2})` }}
        >
          {initials}
        </div>
        <div className="uh-info">
          <div className="uh-name">
            Miner
            <span className="id-chip">ID · {userId}</span>
          </div>
          <div className="uh-meta">
            <div className="meta-item">
              <span>Sponsor:</span>
              <strong>{user ? Number(user.sponsorId) : '—'}</strong>
            </div>
            <div className="meta-item">
              <span>Wallet:</span>
              <strong>{shortenAddress(account, 4)}</strong>
            </div>
          </div>
        </div>
      </div>

      <div className="uh-status">
        <span className={`uh-badge ${isActive ? 'active' : 'inactive'}`}>
          {isActive ? 'Mining Active' : 'Inactive'}
        </span>
        <button className="uh-refresh" onClick={onRefresh} disabled={refreshing}>
          {refreshing ? <Spinner /> : '↻ Refresh'}
        </button>
      </div>
    </div>
  );
}
